import React from 'react';
import MarketingEmptyState from '../shared/MarketingEmptyState';

const ICON = '/products/empty-state-icon.png';

export default function ProductsEmptyState() {
  return (
    <MarketingEmptyState
      iconSrc={ICON}
      i18nPrefix="services"
      titleId="products-empty-title"
      primaryTo="/join"
      secondaryTo="/traders"
    />
  );
}
